<template>
    <nav class="action-navi">
        <ul class="list--unstyled is--actionNavList">
            <li class="is--listItem is--delete" v-if="enableButtons">
                <button ref="intro-delete" class="btn--plain is--icon-left" @click="removeClicked">
                    <i class="icon-close"></i>
                    <span>{{ $t("navigation.delete") }}</span>
                </button>
            </li>
            <li class="is--listItem is--back" v-if="enableButtons">
                <button ref="intro-clipping" class="btn--plain is--icon-left" @click="editClicked">
                    <i class="icon-edit"></i>
                    <span>{{ $t("navigation.edit") }}</span>
                </button>
            </li>
            <li class="is--listItem is--brand">
                <a href="/" class="is--brandLogo">
                    <img src="/custom/plugins/NetiPlexipeopleTheme/Resources/Themes/Frontend/Plexipeople/frontend/_public/src/img/logos/logo.svg" alt="">
                </a>
            </li>
            <li class="is--listItem is--manual" v-if="enableButtons">
                <button class="btn--plain is--icon-left" @click="infoClicked">
                    <i class="icon-info-mark"></i>
                    <span>{{ $t("navigation.manual") }}</span>
                </button>
            </li>
            <li class="is--listItem is--upload is--last" v-show="enableButtons">
                <app-uploader @added="addImage"
                              @filesAdded="$emit('openExtractor', '_uploaded')"
                              @completed="completeImage"
                              :event-prefix="'navigation'"
                              class="panel-uploader"
                              style="position: relative;">
                    <button class="btn--plain is--icon-left" slot="upload-button" ref="intro-upload" style="position: relative; z-index: 1;">
                        <i class="icon-plus"></i>
                        <span>{{ $t("navigation.upload") }}</span>
                    </button>
                </app-uploader>
            </li>
        </ul>
    </nav>
</template>

<script>
    import EventBus from '../event-bus';
    import AppUploader from "./Uploader";
    import AppGuide from "./Guide";
    import { gtag_event } from "../gtag";

    export default {
        props: {
            images: Array,
            plexipeople: Array,
            enableButtons: {
                type: Boolean,
                default: false,
            },
        },

        methods: {
            removeClicked() {
                gtag_event('Button Löschen');
                this.$emit('remove');
            },

            editClicked() {
                gtag_event('Button Bearbeiten');
                this.$emit('openExtractor', undefined, undefined, true);
            },

            infoClicked() {
                gtag_event('Button Anleitung');
                this.$emit('startIntro');
            },

            addImage(file) {
                this.$emit("addImage", file);
            },

            completeImage(file) {
                this.$emit("completeImage", file);
            },

            registerIntroJsStep(config) {
                if ('navigation' !== config.view) {
                    return;
                }

                if (0 === this.plexipeople.length) {
                    config.instance.push({
                        element: this.$refs['intro-upload'],
                        intro: 'Lade hier Dein Foto hoch.',
                        step: 10,
                    });

                    return;
                }

                config.instance.push({
                    element: this.$refs['intro-clipping'],
                    intro: 'Möchtest Du Dein markiertes Element noch\n' + 'einmal überarbeiten, dann klicke hier.',
                    step: 30,
                });

                config.instance.push({
                    element: this.$refs['intro-delete'],
                    intro: 'Hier kannst Du das aktuelle Element löschen',
                    step: 40,
                });

                config.instance.push({
                    element: this.$refs['intro-upload'],
                    intro: 'Möchtest Du ein mehrteiliges Plexipeople bestellen, dann lade hier ein\n' + '<span>weiteres</span> Foto hoch.',
                    step: 100,
                });
            },
        },

        created() {
            EventBus.$on('collectIntroJsSteps', this.registerIntroJsStep);
        },

        beforeDestroy() {
            EventBus.$off('collectIntroJsSteps', this.registerIntroJsStep);
        },

        components: {
            AppUploader,
            AppGuide
        }
    };
</script>

<style scoped lang="scss">
    @import "../assets/scss/components/navigation";
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue